// extracted by mini-css-extract-plugin
export default {"main":"ModalEditarHorario_main__a7V-3","intro":"ModalEditarHorario_intro__iJEW3","rows":"ModalEditarHorario_rows__h2JUh","row":"ModalEditarHorario_row__JGQQr"};